import React from 'react'
import {createSearchParams, Link, useNavigate, useSearchParams} from "react-router-dom";
import Sidebar from "../../../../../components/Sidebar";
import PageHeader from "../../../../../components/PageHeader";
import {toast} from "react-toastify";
import moment from "moment";
import DatePicker, {registerLocale} from "react-datepicker";
import {getSchoolYear} from "../../../../../utils/authority";
import GradeManager, {GRADE_ALL} from "../../../../../components/Grade";
import ClassRoomController from "../../../../../services/data-declaration/class-room-controller";
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import vi from "date-fns/locale/vi";
import NotiController from "../../../../../services/system/noti/noti-controller";
import FilesApi from "../../../../../services/resource/files-api";
import TableHeader from "../../../../../components/TableHeader";
import Pagination from "../../../../../components/Pagination";
import Autocomplete from "@material-ui/lab/Autocomplete";
import TextField from "@material-ui/core/TextField";
import ServiceItemController from "../../../../../services/system/service-item/service-item-controller";
import Utils from "../../../../../utils/utils";
import ServiceOtherController from "../../../../../services/system/service-other/service-other-controller";
import ModalAddStudentToCLB from "../../../clb/register/modalAddStudentToCLB";
import ModalAddStudentToService from "../modalAddStudentToService";
import ServiceOtherRegisterController
    from "../../../../../services/system/service-other-register/service-other-register-controller";
import LinkPlus from "../../../../../components/Link/LinkPlus";
import ModalEditStudentToService from "../modalEditStudentToService";
registerLocale("vi", vi);
function withRouter(Component) {
    return (props) => <Component {...props} navigate={useNavigate()} params={useSearchParams()} />;
}
class DetailRegisterServiceManagement extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            listProduct: [],
            serviceItemResList: [],
            state: "ACTIVE",
            pageNumber: 0,
            pageSize: 100,
            totalItem: 0,

            pageNumberActive: 0,
            pageSizeActive: 50,
            totalItemActive: 0,
            listStudentActive: [],
            isAllSchool: false,
            gradeId: -1,
            currentClassRoomId: -1,

            yearId: parseInt(getSchoolYear()),
            header: [
                {
                    id: "123",
                    name: "STT",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "name",
                    name: "Tên sản phẩm",
                    style: {textAlign: "left"},
                    sort: false
                },
                {
                    id: "price",
                    name: "Giá",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "tax",
                    name: "Thuế",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "action",
                    name: "Đã đăng ký",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "action",
                    name: "Tổng tiền",
                    style: {textAlign: "center"},
                    sort: false
                }
            ],
            headerStudent: [
                {
                    id: "123",
                    name: "STT",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "name",
                    name: "Học sinh",
                    style: {textAlign: "left"},
                    sort: false
                },
                {
                    id: "class",
                    name: "Lớp",
                    style: {textAlign: "left"},
                    sort: false
                },
                {
                    id: "price",
                    name: "Tổng tiền",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "tax",
                    name: "Thuế",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "tax",
                    name: "Đã thanh toán",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "action",
                    name: "Trạng thái",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "action",
                    name: "Hoạt động",
                    style: {textAlign: "center"},
                    sort: false
                }
            ],


            expiredDay: new Date(),
            productName: "",
            groupId: 0,


            content: "",
            classRoomId: 0,
            listClassRoom: [],
        };
    }

    componentWillMount() {
        this.getAllClass()
        this.getListProduct()
        const [searchparams] = this.props.params;
        let serviceOtherId = searchparams.get("id");
        this.setState({
            serviceOtherId: serviceOtherId,
        },()=>{
            this.getData();
        });
    }
    getData() {
        this.getDetailService();
        this.getRegisterInService();
    }
    getRegisterInService() {
        let payload = {
            yearId: parseInt(getSchoolYear()),
            name: this.state.productName,
            serviceOtherId: this.state.serviceOtherId,
            pageNumber: this.state.pageNumber,
            pageSize: this.state.pageSize,
            sort: "created_at desc"
        };
        ServiceOtherRegisterController.listStudentInService(payload, res => {
            this.setState({
                showLoading: false,
                listStudentActive: res.data.content,
            });
        })
    }
    getDetailService = () => {
        ServiceOtherController.registerDetail(this.state.serviceOtherId, res => {
            let data = res.data
            if (data.typeObject === "ALL"){
                this.setState({
                    isAllSchool: true,
                });
            }else if (data.typeObject == "GRADE"){
                this.setState({
                    isAllSchool: false,
                    gradeId: data.valueObject
                });
            }else if (data.typeObject == "CLASS"){
                this.setState({
                    isAllSchool: false,
                    currentClassRoomId: parseInt(data.valueObject)
                });
            }
            if (res.success){
                this.setState(data)
            } else {
                toast.error("Đã xảy ra lỗi! " + res.message)
            }

        })
    };
    getListProduct() {
        let payload = {
            yearId: parseInt(getSchoolYear()),
            name: this.state.productName,
            state: "ACTIVE",
            pageNumber: this.state.pageNumber,
            pageSize: this.state.pageSize,
            sort: "created_at desc"
        };
        ServiceItemController.list(payload, res => {
            this.setState({
                showLoading: false,
                listProduct: res.data.content,
            });
        })
    }
    saveContent(newContent) {
        this.setState({
            content: newContent,
        });
    }
    getAllClass = () => {
        let payload = {
            yearId: parseInt(getSchoolYear()),
            pageNumber: 0,
            pageSize: 1000,
            "sort": "created_at desc"
        };
        ClassRoomController.list(payload, res => {
            this.setState({
                showLoading: false,
                listClassRoom: res.data.content,
            });
        })
    };
    renderClassRoom = () => {
        return this.state.listClassRoom.map((item, index) => <option
            value={item.id}>{item.name}</option>)
    };
    renderStatus() {
        let listStatus = [
            {
                "id": "ACTIVE",
                "name": "Hoạt động"
            },
            {
                "id": "INACTIVE",
                "name": "Khóa"
            }
        ]
        return listStatus.map((item, index) => <option
            value={item.id}>{item.name}</option>)
    }
    onEdit = () => {
        let {name} = this.state;
        let typeObject = "ALL";
        let valueObject = "";
        if (this.state.isAllSchool){
            typeObject = "ALL"
        }else {
            if (this.state.currentClassRoomId > 0){
                typeObject = "CLASS";
                valueObject = this.state.currentClassRoomId;
            }else if(this.state.gradeId.indexOf("GRADE") > -1){
                typeObject = "GRADE";
                valueObject = this.state.gradeId;
            }else {
                typeObject = "";
            }
        }
        if (name == "" || name.length < 5){
            toast.error("Tên dịch vụ/hàng hóa phải lớn hơn 5 ký tự");
        }else if (typeObject == ""){
            toast.error("Vui lòng chọn đối tượng áp dụng");
        }else if (this.state.serviceItemResList.length < 1){
            toast.error("Vui lòng thêm sản phẩm");
        }else {
            let listServiceItem = []
            this.state.serviceItemResList.forEach((product) => {
                listServiceItem.push(product.id)
            })
            let payload = {
                "expiredDay": moment(this.state.expiredDay).format("yyyy-MM-DD hh:mm:ss"),
                "content": this.state.content,
                "yearId": parseInt(getSchoolYear()),
                "name": this.state.name,
                "state": this.state.state,
                "typeObject": typeObject,
                "valueObject": valueObject,
                "listServiceItem": listServiceItem,
                "id": this.state.serviceOtherId,
            }
            ServiceOtherController.edit(payload, res => {
                if (res.success){
                    this.props.navigate('/ad-sas-school/quan-ly-dich-vu-khac');
                    toast.success("Sửa dịch vụ/hàng hóa thành công!")
                } else {
                    toast.error("Đã xảy ra lỗi! " + res.message)
                }
            })
        }
    }
    onUpdateGrade(gradeId){
        this.setState({
            gradeId: gradeId
        }, ()=>{
            if (gradeId === "")
                this.getAllClass()
            else {
                this.getListClass()
            }
        });
    }
    getListClass = () => {
        let payload = {
            name: "",
            grade: this.state.gradeId,
            yearId: parseInt(getSchoolYear()),
            pageNumber: 0,
            pageSize: 1000,
            "sort": "created_at desc"
        };
        ClassRoomController.search(payload, res => {
            this.setState({
                listClassRoom: res.data.content
            });
        })
    };
    getProductSelect(productId){
        let listSelected = this.state.serviceItemResList;
        this.state.listProduct.forEach((product) => {
            if (product.id == productId){
                let item = listSelected.find(item => item.id === product.id);
                if (typeof item === 'undefined'){
                    listSelected.push(product)
                }
            }
        })
        this.setState({
            serviceItemResList: listSelected
        })
    }
    removeProductSelect(productId){
        let filtered = this.state.serviceItemResList.filter(function(el) { return el.id !== productId; });
        this.setState({
            serviceItemResList: filtered
        })
    }
    getObjectName(){
        if (this.state.isAllSchool){
            return 'Toàn trường'
        }else if (this.state.currentClassRoomId > 0){
            return "Lớp "+this.state.currentClassRoomId
        }else{
            for (let i=0; i<GRADE_ALL.length; i++){
                if (GRADE_ALL[i].id === this.state.gradeId){
                    return GRADE_ALL[i].name
                }
            }
        }
    }
    render() {
        let {listStudentActive, serviceItemResList, header, headerStudent} = this.state
        return (
            <div>
                <div className="container">
                    <div className="row">
                        <Sidebar activeClass="register-service" parentClass="service-management"/>
                        <div className="mb-4 col-md-10 tab-content">
                            <div className="card col-12">
                                <div className='pt-3 mb-2'>
                                    <PageHeader routerEnable={true} title="Chi tiết đăng ký dịch vụ"/>
                                    <div className="mt-4 kt-form kt-form--fit kt-margin-b-20">
                                        <h2 className='text-center mb-4'>CHI TIẾT ĐĂNG KÝ DỊCH VỤ</h2>
                                        <div className="row">
                                            <div className="col-xs-12 col-sm-12 col-md-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Tên dịch vụ/Hàng hóa</label>
                                                <label className="col-8 label-item pl-0">{this.state.name}</label>
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Ngày hết hạn đăng ký:</label>
                                                <label className="col-8 label-item pl-0">{moment(this.state.expiredDay).format("DD/MM/YYYY")}</label>

                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Đối tượng áp dụng:</label>
                                                <label className="col-8 label-item pl-0">{this.getObjectName()}</label>
                                            </div>
                                            <div className="col-12 d-flex mb-2 bg-top-title mt-2">
                                                Danh sách sản phẩm/hàng hóa thuộc dịch vụ
                                            </div>
                                            <div className="card col-12">
                                                <div className="p-0 mb-3">
                                                    <div className="table-wrapper">
                                                        <table
                                                            className="table table-striped table-data table-responsive table-bordered">
                                                            <table className="table">
                                                                <thead>
                                                                <TableHeader
                                                                    header={header}
                                                                    clickSort={data => {
                                                                    }}
                                                                />
                                                                </thead>
                                                                {!serviceItemResList ||
                                                                serviceItemResList.length == 0 ? (
                                                                    <tbody>
                                                                    <tr>
                                                                        <td colSpan={12}>
                                                                            <div className="text-center">
                                                                                Không có dữ liệu
                                                                            </div>
                                                                        </td>
                                                                    </tr>
                                                                    </tbody>
                                                                ) : (
                                                                    <tbody>
                                                                    {serviceItemResList &&
                                                                    serviceItemResList.length > 0 &&
                                                                    serviceItemResList?.map((row, index) => (
                                                                        <tr style={{height: 50}}>
                                                                            <td style={{textAlign: "center"}} scope="row">
                                                                                {" "}
                                                                                {this.state.pageNumber * this.state.pageSize +
                                                                                index +
                                                                                1}
                                                                            </td>
                                                                            <td style={{textAlign: "left"}} scope="row">
                                                                                {row.name}
                                                                            </td>
                                                                            <td style={{textAlign: "left"}} scope="row">
                                                                                {Utils.formatMoney(row.price)} VNĐ/1{row.unit}
                                                                            </td>
                                                                            <td style={{textAlign: "center"}}>
                                                                                {Utils.formatMoney(row.tax)} %                                                                            </td>
                                                                            <td style={{textAlign: "center"}}>
                                                                                {row.totalBuy} {row.unit}
                                                                            </td>
                                                                            <td style={{textAlign: "center"}}>
                                                                                {Utils.formatMoney(row.totalBuy*row.price)} VNĐ
                                                                            </td>
                                                                        </tr>
                                                                    ))}
                                                                    </tbody>
                                                                )}
                                                            </table>
                                                        </table>
                                                    </div>
                                                    <div className="pagination-right">
                                                        <Pagination
                                                            activePage={this.state.pageNumber}
                                                            itemsCountPerPage={this.state.pageSize}
                                                            totalItemsCount={this.state.totalItem}
                                                            changeHandler={page => this.handleChangePage(page)}
                                                        />
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-12 d-flex mb-2 bg-top-title mt-2">
                                                Danh sách học sinh đã đăng ký dịch vụ
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-12 p-0 pr-md-3 d-flex mb-1"
                                                 style={{
                                                     alignItems: "center",
                                                     justifyContent: "right"
                                                 }}>
                                                <button
                                                    style={{height: 35, marginRight: 12}}
                                                    type="button"
                                                    className="border-1-s background-btn type-button-fix btn btn-primary btn-sm"
                                                    onClick={() => this.setState({showModalCreate: true})}
                                                >
                                                    Thêm học sinh
                                                </button>
                                            </div>
                                            <div className="card col-12">
                                                <div className="p-0 mb-3">
                                                    <div className="table-wrapper">
                                                        <table
                                                            className="table table-striped table-data table-responsive table-bordered">
                                                            <table className="table">
                                                                <thead>
                                                                <TableHeader
                                                                    header={headerStudent}
                                                                    clickSort={data => {
                                                                    }}
                                                                />
                                                                </thead>
                                                                {!listStudentActive ||
                                                                listStudentActive.length == 0 ? (
                                                                    <tbody>
                                                                    <tr>
                                                                        <td colSpan={12}>
                                                                            <div className="text-center">
                                                                                Không có dữ liệu
                                                                            </div>
                                                                        </td>
                                                                    </tr>
                                                                    </tbody>
                                                                ) : (
                                                                    <tbody>
                                                                    {listStudentActive &&
                                                                    listStudentActive.length > 0 &&
                                                                    listStudentActive?.map((row, index) => (
                                                                        <tr style={{height: 50}}>
                                                                            <td style={{textAlign: "center"}} scope="row">
                                                                                {" "}
                                                                                {this.state.pageNumberActive * this.state.pageSizeActive +
                                                                                index +
                                                                                1}
                                                                            </td>
                                                                            <td style={{textAlign: "left"}} scope="row">
                                                                                {row.studentLiteRes?.fullName}
                                                                            </td>
                                                                            <td style={{textAlign: "left"}} scope="row">
                                                                                {row.studentLiteRes?.currentClassRoomRes?.name}
                                                                            </td>
                                                                            <td style={{textAlign: "center"}}>
                                                                                {Utils.formatMoney(row.money)} VNĐ
                                                                            </td>
                                                                            <td style={{textAlign: "left"}}>
                                                                                {Utils.formatMoney(row.tax)} VNĐ
                                                                            </td>
                                                                            <td style={{textAlign: "left"}}>
                                                                                {Utils.formatMoney(row.totalPayment)} VNĐ
                                                                            </td>
                                                                            <td style={{textAlign: "center"}}>
                                                                                {row.state=="INACTIVE" ? <span className="badge badge-danger" style={{color: "white"}}>Hủy</span> : <span className="badge badge-success" style={{color: "white"}}>Đăng ký</span>}
                                                                            </td>
                                                                            <td style={{textAlign: "center"}}>
                                                                                <button className="btn btn-action p-2"
                                                                                        title='Sửa'
                                                                                        style={{cursor: 'pointer'}}
                                                                                        onClick={() => {
                                                                                            this.setState({itemSelected: row, showModalEdit: true})
                                                                                        }}
                                                                                >
                                                                                    <i className="ti-pencil-alt"/>
                                                                                </button>
                                                                            </td>
                                                                        </tr>

                                                                    ))}
                                                                    </tbody>
                                                                )}
                                                            </table>
                                                        </table>
                                                    </div>
                                                    <div className="pagination-right">
                                                        <Pagination
                                                            activePage={this.state.pageNumberActive}
                                                            itemsCountPerPage={this.state.pageSizeActive}
                                                            totalItemsCount={this.state.totalItemActive}
                                                            changeHandler={page => this.handleChangePage(page)}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="align-right col-12">
                                    <div className="d-flex justify-content-center align-center mt-3 mb-2">
                                        <button
                                            type="button"
                                            className="ml-4 border-1-s background-btn type-button-fix btn btn-primary shadow-none"
                                            disabled={this.state.name == ""}
                                            onClick={()=> {
                                                this.onEdit()
                                            }}
                                        >
                                            Lưu
                                        </button>
                                        <button
                                            type="button"
                                            className="ml-4 border-1-s type-button-fix btn btn-light shadow-none"
                                        >
                                            <Link
                                                style={{color: '#000'}}
                                                to={{
                                                    pathname: "/ad-sas-school/quan-ly-dang-ky-dich-vu"
                                                }}
                                            >
                                                Hủy bỏ
                                            </Link>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <ModalAddStudentToService
                    show={this.state.showModalCreate}
                    onHide={() => this.setState({showModalCreate: false})}
                    onRefresh={() => this.getData()}
                    serviceItems={this.state.serviceItemResList}
                    typeObject={this.state.typeObject}
                    valueObject={this.state.valueObject}
                    serviceOtherId={this.state.serviceOtherId}
                />
                <ModalEditStudentToService
                    show={this.state.showModalEdit}
                    onHide={() => this.setState({showModalEdit: false})}
                    onRefresh={() => this.getData()}
                    serviceOtherId={this.state.serviceOtherId}
                    itemSelected={this.state.itemSelected}
                />
            </div>
        )
    }
}

export default withRouter(DetailRegisterServiceManagement)
